import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { AtomsModule } from '@library/ui/atoms/atoms.module'
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { LayoutModule } from '@library/ui/layout/layout.module';
import { InputTimeComponent } from './input-time.component';
import { InputTimeDirective } from './input-time.directive';


@NgModule({
  declarations: [
    InputTimeComponent,
    InputTimeDirective
  ],
  exports: [
    InputTimeComponent,
    InputTimeDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    AtomsModule,
    PipesModule,
    LayoutModule
  ],
})
export class InputTimeModule { }
